// Categories: Featured, Web App, Mobile App, Desktop App, UX Design

const portfolioData = [
    {
      id: 1,
      title: 'Appointment Scheduler',
      img: '/assets/projects/scheduler.png',
      tags: ['featured', 'desktop',''],
      url: 'https://github.com/mocha-maker/Universal-Consultants-Scheduler',
    },
    {
      id: 2,
      title: 'Academic Planner',
      img: '/assets/projects/acadplanner.png',
      tags: ['featured', 'mobile',''],
      url: 'https://github.com/mocha-maker/Academic-Planner',
    },
    {
      id: 3,
      title: 'Taniti Island Website Redesign',
      img: '/assets/projects/taniti-design.png',
      tags: ['featured', 'design',''],
      url: 'https://mocha-maker.github.io/taniti-prototype/',
    },
    {
      id: 4,
      title: 'Quote Generator',
      img: '/assets/projects/quote-generator.png',
      tags: ['web',''],
      url: 'https://mocha-maker.github.io/quote-generator/',
    },
    {
      id: 5,
      title: 'Pet Consulting Website',
      img: '/assets/projects/pet-consulting.png',
      tags: [ 'design','' ],
      url: 'https://mocha-maker.github.io/paradigmpet-prototype/',
    },
    {
      id: 6,
      title: 'Feedback App',
      img: '/assets/projects/feedback-app.png',
      tags: ['web','featured'],
      url: 'https://github.com/mocha-maker/feedback-ui/',
    },
    {
      id: 7,
      title: 'Github Finder App',
      img: '/assets/projects/feedback-app.png',
      tags: ['web','featured'],
      url: 'https://github.com/mocha-maker/github-finder/',
    },
  ]

  export default portfolioData;